var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagPitcairnIslands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 24.8365 24.8365 32 16 32C7.1635 32 0 24.8365 0 16C0 16.0038 16 0.00175 16 0C24.8365 0 32 7.1635 32 16Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9572 16.0001H16C16 15.9857 16 15.9717 16 15.9573C15.9858 15.9716 15.9715 15.9858 15.9572 16.0001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34781C16 5.5325 16 3.68781 16 0H15.9973C7.16194 0.0015 0 7.16431 0 16H8.34781V11.2993L13.0485 16H15.9572C15.9715 15.9858 15.9858 15.9715 16.0001 15.9572C16.0001 14.8793 16.0001 13.9174 16.0001 13.0486L11.2992 8.34781H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09466 2.08691C5.59223 3.51185 3.51179 5.59223 2.08691 8.09466V16H6.26085V6.26098V6.26085H16C16 4.94441 16 3.69029 16 2.08691H8.09466Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.0325L10.3153 8.3479H8.34778V8.34803L15.9998 16H16C16 16 16 14.6433 16 14.0325Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0435 9.73924L22.9565 10.4349L20.8696 9.73924L20.174 8.00011L20.8696 6.26099H25.0435L24.3478 8.00011L25.0435 9.73924Z",
    fill: "#ACABB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0869 9.73901V17.3911C18.0869 21.1186 22.9565 22.2608 22.9565 22.2608C22.9565 22.2608 27.826 21.1186 27.826 17.3911V9.73901H18.0869Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5264 19.2042C19.7234 21.5022 22.957 22.2609 22.957 22.2609C22.957 22.2609 26.1906 21.5022 27.3876 19.2042L22.957 11.8262L18.5264 19.2042Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.826 17.3138L22.9565 9.73901L18.0869 17.3139V17.3911C18.0869 18.081 18.254 18.6821 18.5259 19.204L22.9565 12.3118L27.3871 19.204C27.6589 18.682 27.826 18.081 27.826 17.3911V17.3138Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagPitcairnIslands);
export default __webpack_public_path__ + "static/media/flag_pitcairn_islands.7f5d0e231f4e98d8e80bfe4967888dd0.svg";
export { ForwardRef as ReactComponent };